import React from 'react'

interface NumberInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  value?: number | string
  onChange?: (val: string) => void
  onBlur?: (val: string) => void
  isDirty?: boolean
  mono?: boolean
  label?: string
  hint?: string
}

export const NumberInput = React.forwardRef<HTMLInputElement, NumberInputProps>(
  ({ value, onChange, onBlur, isDirty = false, mono = false, label, hint, style, disabled, ...rest }, ref) => {
    const borderColor = isDirty ? 'rgba(234,179,8,0.5)' : 'var(--border)'
    const bgColor     = isDirty ? 'rgba(234,179,8,0.08)' : 'var(--bg-elevated)'

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
        {label && (
          <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)' }}>
            {label}
          </label>
        )}
        <input
          ref={ref}
          type="number"
          value={value}
          onChange={e => onChange?.(e.target.value)}
          onBlur={e => onBlur?.(e.target.value)}
          disabled={disabled}
          style={{
            width: '100%',
            padding: '0.4rem 0.5rem',
            background: bgColor,
            border: `1px solid ${borderColor}`,
            borderRadius: 6,
            color: 'var(--text-primary)',
            fontSize: '0.78rem',
            fontFamily: mono ? 'var(--font-mono, monospace)' : 'inherit',
            outline: 'none',
            textAlign: 'right',
            boxSizing: 'border-box',
            transition: 'border-color 0.15s, background 0.15s',
            ...(disabled ? { opacity: 0.6, cursor: 'not-allowed' } : {}),
            ...style,
          }}
          {...rest}
        />
        {hint && (
          <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{hint}</span>
        )}
      </div>
    )
  }
)
NumberInput.displayName = 'NumberInput'
